<template>
  <div class="orderpackcaontein">
    <md-field>
      <md-cell-item title="配送類型" arrow @click="typeshow = true" :addon="type.label" v-if="ispae">
      </md-cell-item>
      <md-cell-item title="配送類型" :addon="type.label" v-if="!ispae">
      </md-cell-item>
      <md-cell-item title="添加收貨地址" arrow v-if="par.address && !par.address.id" @click="toaddresh">
        <md-icon name="location" size="lg" slot="left"></md-icon>
      </md-cell-item>
      <md-cell-item :title="par.address.name + ' , ' + par.address.mobile" :brief="alladdres" arrow v-else
                    @click="toaddresh">
        <div slot="left" style="
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-around;
          ">
          <md-tag size="large" shape="fillet" type="fill" fill-color="#2f86f6" font-weight="normal" font-color="#ffffff"
                  v-if="par.address.isSuperMall == 0">宅配
          </md-tag>
          <md-tag size="large" shape="fillet" type="fill" style="margin-top: -0.1rem" fill-color="#2f86f6"
                  font-weight="normal" font-color="#ffffff" v-else>店配
          </md-tag>
          <md-tag size="large" shape="fillet" type="fill" fill-color="#eeeeee" font-weight="normal" font-color="#000000"
                  style="margin-top: 0.1rem" v-if="par.address.isSuperMall != 0">
            <span v-if="par.address.mallBrand == 1">全家</span>
            <span v-if="par.address.mallBrand == 2">711</span>
          </md-tag>
        </div>
      </md-cell-item>
    </md-field>
    <div style="width: 100%; height: 0.1rem"></div>
    <!-- 申报人列表 -->
    <div class="declared_container" v-if="par.address.countryId === '158'">
      <div class="empty_declared" v-if="declarantList.length === 0">
        <md-notice-bar :multi-rows="true">增加更多申报人收件人不做申报，如需收件人申报请增加到更多申报人</md-notice-bar>
      </div>
      <div v-else style="width: 100%">
        <table border="0">
          <tr class="header">
            <th>姓名</th>
            <th>聯系電話</th>
            <th>證件號</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in declarantList" :key="index" class="content">
            <td>{{ item.name }}</td>
            <td>{{ item.mobile }}</td>
            <td>{{ item.certificateNo }}</td>
            <td>
              <md-icon name="clear" color="gray" size="md" @click="deleteDeclarant(item, index)">
              </md-icon>
            </td>
          </tr>
        </table>
      </div>
      <md-button size="small" type="primary" plain style="width: 3rem;margin-top: 0.2rem"
                 @click="toDeclarantList">增加更多申報人
      </md-button>
      <!-- <md-field class="noright uwne">
        <md-cell-item
          title="报关需求"
          :brief="customsDeclara"
          @click="iscusto = true"
          no-border
          ><div slot="right" style="width: 0.8rem">
            <img
              src="@/assets/image/icon_dropdown.png"
              alt=""
              style="width: 0.5rem"
            />
          </div>
        </md-cell-item>
      </md-field> -->
    </div>
    <!-- 包裹明細 -->
    <p class="title" style="font-size: 0.32rem">包裹明細</p>
    <div class="packcontilist">
      <div class="listmkck">
        <div class="listpack">
          <div class="packindex"></div>
          <div class="packnumber">
            <span>包裹單號</span>
          </div>
          <div class="packtype">
            <span>類型</span>
          </div>
          <div class="packweight">
            <span>实重</span>
          </div>
          <div class="packvalue">
            <span>计费重</span>
          </div>
        </div>
        <div class="listpack" v-for="(item, index) in par.parcelList" :key="index">
          <div class="packindex">
            <span>{{ index + 1 }}</span>
          </div>
          <div class="packnumber">
            <span>{{ item.expressNumber }}</span>
          </div>
          <div class="packtype">
            <span v-if="item.type == 1">特貨</span>
            <span v-else>普貨</span>
          </div>
          <div class="packweight">
            <span>{{ item.realWeight }}KG</span>
          </div>
          <div class="packvalue">
            <span>{{ item.bulk }}KG</span>
          </div>
        </div>
        <div class="listpack">
          <div class="packindex">

          </div>
          <div class="packnumber">
            <span>合计</span>
          </div>
          <div class="packtype">

          </div>
          <div class="packweight">
            <span>{{ par.realWeight }}KG</span>
          </div>
          <div class="packvalue">
            <span>{{ par.bulk }}KG</span>
          </div>
        </div>
      </div>
      <div class="allshow">
        <p style="margin-top: 0.2rem;padding-left: 0.55rem;">
        <span>申报總值：<md-amount :value="par.totalPrice" has-separator></md-amount>
          <span>CNY</span></span>
        </p>
      </div>
      <md-field v-if="shoremark">
        <md-input-item ref="input0" title="订单备注" v-model="remark" placeholder="有特殊需求请备注"
                       style="font-size: 0.26rem"/>
      </md-field>
    </div>

    <div style="height:0.6rem ;background-color: #ffffff;" v-if="!shoremark"></div>
    <!-- 費用計算 -->
    <p class="title" v-if="par.address.id" style="font-size: 0.32rem">費用計算</p>
    <md-field class="noright" v-if="par.address.id&&pickerData">
      <md-cell-item title="線路" :brief="country" @click="isPickerShow = true" no-border>
        <div slot="right" style="width: 0.8rem">
          <img src="@/assets/image/icon_dropdown.png" alt="" style="width: 0.5rem"/>
        </div>
        <div slot="children" class="cheildercomt" v-if="par.billing">
          <p v-if="par.billing.memo">
            {{ par.billing.memo }},預計{{ par.billing.fastestDay }}~{{
              par.billing.latestDay
            }}天到達
          </p>
          <p v-if="!par.billing.memo" style="color: #e51c23">
            重量不在價格區間內
          </p>
          <p v-if="chargeMode===2" style="color: orangered;margin-top: 0.1rem">
            打包后付款，以打包后实际重量计费
          </p>
        </div>
      </md-cell-item>
      <md-cell-item title="超費期" :brief="timeOutPrice" v-if="timeOutPrice > 0">
        <div slot="right" style="width: 0.8rem"></div>
      </md-cell-item>
      <div v-if="chargeMode===1">
        <div v-for="(item, index) in par.triggerParcelTotalSurchargesMoney.list" :key="index">
          <md-cell-item :title="item.name" :brief="item.totalPrice + ' CNY'" @click="getsunue(item)">
            <div slot="right" style="width: 0.8rem"></div>
          </md-cell-item>
        </div>
        <md-cell-item title="附加费" :brief="par.parcelTotalSurchargesMoney + ' CNY'"
                      v-if="par.parcelTotalSurchargesMoney > 0" @click="showCustomTransition = true">
          <div slot="right" style="width: 0.8rem"></div>
        </md-cell-item>
      </div>
      <md-cell-item title="運費" :brief="yunprice + ' CNY'" v-if="chargeMode===1&&!gradecomt">
        <div slot="right" style="width: 0.8rem"></div>
      </md-cell-item>
      <md-cell-item title="運費" v-if="chargeMode===1&&gradecomt">
        <div slot="default" style="width: 74%;display: flex;justify-content: flex-start;font-size: 0.3rem">
          <span style="text-decoration:line-through;margin-right: 0.25rem"
                v-if="gradecomt.discount!=10">{{ yunprice }}CNY</span>
          <span style="color: orangered;">{{ (yunprice * gradecomt.discount / 10).toFixed(2) }}CNY</span>
          <span style="margin-left: 0.1rem"
                v-if="gradecomt.discount!=10">(Lv.{{ gradecomt.name }}{{ gradecomt.discount }}折)</span>
          <span style="margin-left: 0.1rem" v-if="gradecomt.discount===10">(Lv.{{ gradecomt.name }}无折扣)</span>
        </div>
        <!--        <div slot="right" style="width: 0.8rem"></div>-->
      </md-cell-item>
      <md-cell-item title="運費" :brief="yunprice + ' CNY (预估)'" v-if="chargeMode===2">
        <div slot="right" style="width: 0.8rem"></div>
      </md-cell-item>

      <md-cell-item :title="par.billing.taxRate" :brief="par.billing.rat + ' CNY'"
                    v-if="par.billing && par.billing.isGoodsTax == 1">
        <div slot="right" style="width: 0.8rem"></div>
      </md-cell-item>
      <md-cell-item title="代收款">
        <div slot="default" style="display: flex;font-size: 0.26rem;width: 75%">
          <div v-if="par.address.id && par.address.isReplace == 1"
               style="display: flex;align-items: center;width: 100%">
            <md-switch v-model="replace" style="margin-right: 0.1rem" @change="cheurusner()"></md-switch>
            <span>代收</span>
            <div style="width: 65%;margin-left: 4%;margin-top: -0.4rem">
              <md-input-item ref="input0" v-if="replace && par.address.isReplace == 1" v-model="replacePrice"
                             placeholder="代收金額" @blur="cheurusner()" style="height: 0.6rem">
                <div class="input-operator" slot="right">新臺幣</div>
              </md-input-item>
            </div>
          </div>

        </div>
      </md-cell-item>
      <md-cell-item title="增值服務" no-border>
        <div slot="children" class="cheildercomtonier">
          <p class="switchItem" v-for="(item, index) in addedlist" :key="index">
            <md-switch v-model="item.status" @change="hanchangeone(item.id, item.splitChargeType, item.name, index)"
                       style="margin-right: 0.05rem"></md-switch>
            <span style="margin-right: 0.2rem">{{ item.name }}</span>
            <md-amount style="color: #e51c23" :value="item.addedPrice" has-separator
                       v-if="item.splitChargeType === 1"></md-amount>
            <span style="color: #e51c23" v-if="item.splitChargeType === 1">CNY</span>
            <md-amount style="color: #e51c23" :value="item.addedPrice" has-separator
                       v-if="item.splitChargeType === 2 && item.status"></md-amount>
            <span style="color: #e51c23" v-if="item.splitChargeType === 2 && item.status">CNY</span>
          </p>
        </div>
      </md-cell-item>
      <md-cell-item title="優惠券" :brief="counp" @click="getcouefrt" v-if="chargeMode===1">
        <div slot="right" style="width: 0.8rem">
          <img src="@/assets/image/icon_dropdown.png" alt="" style="width: 0.5rem"/>
        </div>
        <div slot="children" style="font-size: 0.26rem; color: #e51c23; text-align: left">
          增值服務和稅收產生的費用不在優惠範圍內
        </div>
      </md-cell-item>
      <!-- 积分抵扣 -->
      <md-cell-item title="积分抵扣" v-if="Number(creditPrice) > 0&&chargeMode===1">
        <span style="color: #e51c23;font-size: 0.26rem">可抵扣{{ creditPrice }}CNY(消耗{{ creditValue }}积分)</span>
        <md-switch v-model="creditStatus" @change="changeAllPrice"></md-switch>
      </md-cell-item>

    </md-field>

    <md-picker ref="picker1" v-if="pickerData.length > 0" v-model="isPickerShow" :data="pickerData" :cols="1"
               title="線路"
               @confirm="onPickerConfirm()"></md-picker>

    <md-picker ref="picker4" v-if="coustkerData.length > 0" v-model="iscusto" :data="coustkerData" :cols="1"
               title="报关需求" @confirm="onPickercust()"></md-picker>
    <md-action-sheet v-model="typeshow" title="配送类型" :options="pickerDatatype" @selected="$_selected"
                     @cancel="typeshow = false"></md-action-sheet>
    <md-popup v-model="isSelectorShow" position="bottom">
      <md-popup-title-bar title="優惠券" ok-text="确认" cancel-text="不使用" large-radius @confirm="onSelectorChoose"
                          @cancel="hidePopUp"></md-popup-title-bar>
      <div class="coupcontainer" v-if="allcoupons.length > 0">
        <div v-for="(item, index) in allcoupons" :key="index" :class="
          item.thresholdPrice <= yunprice ? 'coupitem' : 'coupitem nocolor'
        " @click="getcoupindex(index)">
          <div class="coupitemleft">
            <p v-if="item.type != 2" style="font-size: 0.43rem; color: orangered">
              ¥
              <md-amount :value="item.price" :precision="2"></md-amount>
            </p>
            <span v-if="item.type == 2" style="font-size: 0.43rem; color: orangered">{{ item.price }}折</span>
            <p v-if="item.thresholdPrice > 0" style="color: rgba(183, 183, 183, 1); font-size: 0.26rem">
              滿
              <md-amount :value="item.thresholdPrice" :precision="2"></md-amount>
              可用
            </p>
            <p v-if="item.thresholdPrice == 0" style="color: rgba(183, 183, 183, 1); font-size: 0.26rem">
              無門檻使用
            </p>
          </div>
          <div class="coupitemright">
            <span style="font-size: 0.38rem">{{ item.name }}</span>
            <span style="color: rgba(183, 183, 183, 1); font-size: 0.24rem">{{
                item.beginTime | dateformat("YYYY-MM-DD")
              }}-{{
                item.endTime | dateformat("YYYY-MM-DD")
              }}</span>
          </div>
          <img src="@/assets/image/chose.jpg" alt="" class="messageimg" v-if="coupcde == index"/>
        </div>
      </div>
    </md-popup>
    <!-- 弹出公告 -->
    <md-landscape v-model="showCustomTransition" transition="md-bounce" :mask-closable="false">
      <div class="eJectModal">
        <div class="title" style="font-size: 0.32rem">
          附加费
        </div>
        <div class="content">
          <div class="packcontilist">
            <div class="listmkck">
              <div class="listpack">
                <div class="packnumber">
                  <span>包裹單號</span>
                </div>
                <div class="packvalue">
                  <span>附加费</span>
                </div>
              </div>
              <div class="listpack bordernone" v-for="(item, index) in par.parcelList" :key="index">
                <div class="packnumber">
                  <span>{{ item.expressNumber }}</span>
                </div>
                <div class="packvalue maxlengt" v-if="item.surchargesMemo">
                  <span>{{ item.surchargesMemo }}:</span>
                  <md-amount :value="item.surchargesMoney" has-separator></md-amount>
                  CNY
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-landscape>
    <md-landscape v-model="showCustomTrasunuw" transition="md-bounce" :mask-closable="false">
      <div class="eJectModal">
        <div class="title">
          {{ showCustomTrastitle }}
        </div>
        <div class="content">
          <div class="packcontilist">
            <div class="listmkck">
              <div class="listpack">
                <div class="packnumber" style="width: 70%">
                  <span>条件</span>
                </div>
                <div class="packvalue">
                  <span>内容</span>
                </div>
              </div>
              <div class="listpack bordernone" v-for="(item, index) in anjsnjlis" :key="index">
                <div class="packnumber" style="width: 70%">
                  <span>{{ item.type }}</span>
                </div>
                <div class="packvalue maxlengt">
                  <span>{{ item.value }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </md-landscape>
    <md-landscape v-model="showemail" transition="md-bounce" :mask-closable="false">
      <div class="emadilcontainer">
        <h3>绑定邮箱</h3>
        <md-field>
          <md-input-item ref="input0" v-model="email" placeholder="請輸入郵箱" @change="checkBankCard">
            <img src="@/assets/image/icon_email.png" alt="" slot="left" class="logo"/>
            <p v-if="isError" class="error" slot="error">
              請輸入正確的郵箱地址
            </p>
          </md-input-item>
          <md-input-item ref="input0" v-model="code" placeholder="請輸入郵箱驗證碼" :maxlength="6" type="digit"
                         @change="checkBankcode">
            <div class="codecontaine" slot="right">
              <span @click="send" style="color: #097ef7">{{ time }}</span>
            </div>
            <img src="@/assets/image/icon_trade.png" alt="" slot="left" class="logo"/>
            <p v-if="isErrorcode" class="error" slot="error">
              請輸入正確的郵箱驗證碼
            </p>
          </md-input-item>
          <md-input-item ref="input0" v-model="passWord" placeholder="請輸入密碼" :maxlength="20"
                         :type="showpass ? 'password' : 'text'" @change="checkBankpassWord">
            <md-icon :name="showpass ? 'invisible' : 'visible'" size="lg" slot="right"
                     @click="showpass = !showpass"></md-icon>
            <img src="@/assets/image/icon_pwd.png" alt="" slot="left" class="logo"/>
            <p v-if="isErrorpas" class="error" slot="error">
              請輸入6~20比特非純數位密碼
            </p>
          </md-input-item>
          <md-input-item ref="input0" v-model="passWordold" placeholder="請再次輸入密碼" :maxlength="20"
                         :type="showpassold ? 'password' : 'text'" @change="checkBankpassWordold">
            <md-icon :name="showpassold ? 'invisible' : 'visible'" size="lg" slot="right"
                     @click="showpassold = !showpassold"></md-icon>
            <img src="@/assets/image/icon_pwd.png" alt="" slot="left" class="logo"/>
            <p v-if="isErrorpasold" class="error" slot="error">
              兩次輸入密碼不一致
            </p>
          </md-input-item>
        </md-field>
        <div style="margin-top:0.5rem">
          <md-button :type="isclick && isvalue ? 'warning' : 'disabled'" round
                     style="width: 90%; margin-left: 5%; height: 0.9rem" @click="login">
            <md-activity-indicator v-if="loading" class="md-activity-indicator-css" type="carousel" :size="15"
                                   color="#fff" text-color="#fff"></md-activity-indicator>
            <span v-else>确定</span>
          </md-button>
        </div>
      </div>
    </md-landscape>
    <div style="width: 100%; height: 1.2rem"></div>
    <div style="width: 100%; height: 0.6rem" v-if="chargeMode===2"></div>
    <div
      style="display: flex;align-items: center;justify-content: center;font-size: 0.2rem;width: 100%;position: fixed;bottom: 1rem;height: 0.6rem;background-color: yellow;color: orangered"
      v-if="chargeMode===2">
      <span>请注意，预估金额只作为参考，实际支付金额以打包确认后为准</span>
    </div>
    <div class="bootomsubmit" v-if="par.address.id">
      <p v-if="chargeMode===1">
        合计：<span>{{ allprice }} CNY</span>
      </p>
      <p v-if="chargeMode===2">预估金额：<span>{{ allprice }} CNY</span>
      </p>
      <md-button :type="Number(allprice) > 0 ? 'warning' : 'disabled'" :loading="loading" size="small" inline
                 style="height: 100%; width: 2rem" @click="summit"><span v-if="chargeMode===1">提交</span>
        <span v-if="chargeMode===2">提交打包</span>
      </md-button>
    </div>
    <md-popup v-model="shotable">
      <md-popup-title-bar only-close large-radius :title="title" title-align="left" @cancel="shotable = false">
      </md-popup-title-bar>
      <div class="md-example-popup md-example-popup-align">
        <md-scroll-view :scrolling-x="false">
          <div class="headerchek">
            <div class="cheicon" @click="cheall()">
              <md-icon name="check" size="lg" v-if="!checlist.check" color="orange"></md-icon>
              <md-icon name="checked" size="lg" v-if="checlist.check" color="orange"></md-icon>
            </div>
            <div class="chetyle">全选</div>
            <div class="weigconten">重量</div>
            <div class="volumche">体积</div>
          </div>
          <div class="unskr">
            <div v-for="(item, index) in checlist.parcelList" :key="index">
              <div class="headeritem">
                <div class="cheicon" @click="cheindex(index)">
                  <md-icon name="check" size="lg" v-if="!item.check" color="orange"></md-icon>
                  <md-icon name="checked" size="lg" v-if="item.check" color="orange"></md-icon>
                </div>
                <div class="chetyle">{{ item.expressNumber }}</div>
                <div class="weigconten">{{ item.weight }}kg</div>
                <div class="volumche">{{ item.volume }}CBM</div>
              </div>
            </div>
          </div>
          <div class="bottomview">
            <span>合计：{{ checlist.addprc }}CNY</span>
            <div class="unsuner">
              <md-button type="warning" size="small" inline @click="shurepae()">确定</md-button>
            </div>
          </div>
        </md-scroll-view>
      </div>
    </md-popup>
  </div>
</template>

<script>
import {
  Field,
  CellItem,
  Tag,
  ActionSheet,
  ActivityIndicator,
  Toast,
  Icon,
  Picker,
  Button,
  Amount,
  Switch,
  InputItem,
  Selector,
  Popup,
  Landscape,
  PopupTitleBar,
  NoticeBar,
  Dialog,
  ScrollView,
} from 'mand-mobile';
import GoodModal from './Modal/GoodModal';
import eventBus from '../../until/eventBus';
import {isBlank} from '../../until/common';
import md5 from 'js-md5';


export default {
  name: 'orderpack',
  components: {
    [Popup.name]: Popup,
    [ScrollView.name]: ScrollView,
    [ActionSheet.name]: ActionSheet,
    [PopupTitleBar.name]: PopupTitleBar,
    [InputItem.name]: InputItem,
    [Field.name]: Field,
    [CellItem.name]: CellItem,
    [ActivityIndicator.name]: ActivityIndicator,
    [Icon.name]: Icon,
    [Picker.name]: Picker,
    [Tag.name]: Tag,
    [Landscape.name]: Landscape,
    [Amount.name]: Amount,
    [Selector.name]: Selector,
    [Button.name]: Button,
    [Switch.name]: Switch,
    [NoticeBar.name]: NoticeBar,
    [Dialog.name]: Dialog,
    // eslint-disable-next-line vue/no-unused-components
    GoodModal,
  },
  data() {
    return {
      isshowModal:false,
      checkindex: 0,
      shotable: false,
      isError: false,
      time: '獲取驗證碼',
      showCustomTrasunuw: false,
      showCustomTrastitle: '',
      anjsnjlis: [],
      currentTime: 60,
      ispae: true,
      email: '',
      passWordold: '',
      shoremark: false,
      isErrorpasold: false,
      passWord: '',
      isErrorcode: false,
      isErrorpas: false,
      code: null,
      isclick: false,
      disabled: true,
      addedlist: [],
      title: '',
      showpass: false,
      showpassold: false,
      showCustomTransition: false,
      showemail: false,
      isSelectorShow: false,
      isPickerShow: false,
      replace: false,
      checkedone: false,
      parcelList: [],
      loading: false,
      isReinforce: 0,
      customsDeclara: '',
      iscusto: false,
      isProtection: 0,
      chargeMode: 1,
      customsDeclarationDemand: 0,
      par: {
        address: {
          id: '',
          name: '',
        },
      }, // 配送地址数据
      type: {label: '宅配', value: '1'},
      yunprice: '',
      grancount: '',
      coupcde: null,
      typeshow: false,
      countryList: [],
      country: '',
      elapsedTime: '',
      allcoupons: [],
      replacePrice: '',
      countryid: '',
      counp: '',
      checkedtwo: false,
      timeOutPrice: '',
      coupid: '',
      alladdres: '',
      shopid: null,
      coupprice: 0,
      remark: '',
      gradecomt: null,
      isRein: {
        isProtection: false,
        isReinforce: false,
      },
      checlist: {addprc: 0, check: false},
      allprice: '',
      pickerData: [],
      coustkerData: [],
      pickerDatatype: [
        {label: '宅配', value: '1'},
        {label: '超商配送', value: '2'},
      ],
      // 申报人
      declarantList: [],
      // 积分抵扣
      creditStatus: false,
      creditPrice: 0,
      creditValue: null,
    };
  },
  created() {
    // 修改配送地址广播监听
    eventBus.$on(
      'useraddres',
      function (data, index) {
        if (this.par.address.id) {
          if (this.par.address.id != data.id) {
            this.shopid = null;
            this.par.address = data;
            if(!this.isshowModal){
              this.checkEntrust()
            }

          }
        } else {
          this.par.address = data;
        }
      }.bind(this)
    );

    // 更新申报人
    eventBus.$on(
      'setDeclarant',
      function (data) {
        for (let i in this.declarantList) {
          if (this.declarantList[i].id === data.id) {
            return false;
          }
        }
        this.declarantList.push(data);
      }.bind(this)
    );
  },
  activated() {
    // 获取历史申报人列表
    // this.getDeclareHistoryList();

    // 是否可以超商配送
    this.hasMallInfo();

    if (localStorage.getItem('chajkskl')) {
      this.shopid = localStorage.getItem('chajkskl');
      localStorage.removeItem('chajkskl');
    }

    if (
      localStorage.getItem('addorder') &&
      this.$route.query.shopid == undefined
    ) {
      this.shopid = null;
      this.type = this.pickerDatatype[0];
      localStorage.removeItem('addorder');
      this.pickerData = [];
      this.csancelcoup();
      Toast.loading('加载中...');
      this.getdetaile();
    } else if (this.$route.query.shopid != undefined) {
      if (localStorage.getItem('fleshpei')) {
        //console.log(localStorage.getItem("fleshpei"));
        localStorage.removeItem('fleshpei');
      } else {
        this.shopid = this.$route.query.shopid;
        this.pickerData = [];
        this.csancelcoup();
        Toast.loading('加载中...');
        this.getdetaile();
      }
    } else {
      if (this.shopid) {
        this.getshopid();
      } else if (!localStorage.getItem('chageaderes')) {
        this.pickerData = [];
        this.csancelcoup();
        Toast.loading('加载中...');
        this.getdetaile();
      } else {
        localStorage.removeItem('chageaderes');
        this.shopid = null;
        this.csancelcoup();
        this.getalladdres();
        this.par.address.id ? this.getServe(this.par.address.countryId) : null;
        this.par.address.id
          ? this.servicePricelist(this.par.address.countryId)
          : null;
      }
    }
    console.log(this.par);
    // 积分抵扣
    // this.getCreditPrice()
  },
  methods: {
    isBlank,
    // 获取用户积分抵扣 (选中优惠券后获取)
    getCreditPrice() {
      if (this.chargeMode === 2) {
        return
      }
      const param = {
        countryId: this.par.address.countryId,
        couponId: this.coupid,
        totalPrice: this.par.billing.price,
      };

      this.http
        .APIASK(this.ports.getCreditPrice, 'get', param)
        .then((res) => {
          this.creditStatus = res.creditStatus;
          this.creditPrice = res.creditPrice;
          this.creditValue = res.creditValue;
          this.changeAllPrice();
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    getsunue(item) {
      this.showCustomTrastitle = item.name;
      this.showCustomTrasunuw = true;
      this.anjsnjlis = item.list;
      console.log(item);
    },
    checkBankcode() {
      if (this.code && this.code.length == 6) {
        this.isErrorcode = false;
        this.checkallerr();
      } else {
        this.isErrorcode = true;
      }
    },
    checkBankCard() {
      var reg = new RegExp(
        '^\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$'
      );

      if (!reg.test(this.email.trim())) {
        this.isError = true;
      } else {
        this.checkallerr();
        this.isError = false;
      }
    },
    isNumberOr_Letter(s) {
      var regu = '^(?=.*\\d)(?=.*[a-z])[a-zA-Z\\d]{6,20}$';
      var re = new RegExp(regu);
      if (re.test(s)) {
        return true;
      } else {
        return false;
      }
    },
    checkBankpassWord() {
      if (this.isNumberOr_Letter(this.passWord)) {
        this.isErrorpas = false;
        this.checkallerr();
      } else {
        this.isErrorpas = true;
        if (this.passWordold) {
          this.checkBankpassWordold();
        }
      }
    },
    checkallerr() {
      if (
        !this.isErrorpasold &&
        !this.isError &&
        !this.isErrorpas &&
        !this.isErrorcode
      ) {
        this.isclick = true;
      } else {
        this.isclick = false;
      }
      if (this.passWord && this.passWordold && this.email && this.code) {
        this.isvalue = true;
      } else {
        this.isvalue = false;
      }
    },
    checkBankpassWordold() {
      if (this.passWord != this.passWordold) {
        this.isErrorpasold = true;
      } else {
        this.isErrorpasold = false;
        this.checkallerr();
      }
    },
    // 邮箱验证码
    send() {
      const _this = this;
      if (_this.email && _this.disabled) {
        const par = {
          email: _this.email.trim(),
        };
        par.appCode = localStorage.getItem('userinfoMobie')
          ? JSON.parse(localStorage.getItem('userinfoMobie')).shopCode
          : localStorage.getItem('shopkey')
            ? JSON.parse(localStorage.getItem('shopkey')).appCode
            : null;
        this.http
          .APIASK(this.ports.sendEmailCode, 'post', par)
          .then((res) => {
            let interval = null;
            let currentTime = _this.currentTime;
            interval = setInterval(function () {
              currentTime--;
              _this.time = currentTime + 'S';
              if (currentTime <= 0) {
                clearInterval(interval);
                _this.time = '获取验证码';
                _this.currentTime = 60;
                _this.disabled = true;
              }
            }, 1000);
            _this.iconDialog.open = true;
            _this.disabled = false;
          })
          .catch((err) => {
            if (err.code == 406) {
              _this.$emit('islogin');
            }
            (_this.time = '获取验证码'),
              (_this.currentTime = 60),
              (_this.disabled = true);
          });
      } else if (!_this.email && _this.disabled) {
        Toast({content: '請輸入emai地址', duration: 3000});
      } else if (_this.email && !_this.disabled) {
        Toast({content: '驗證碼已發送', duration: 3000});
        return false;
      }
    },
    login() {
      this.loading = true;
      const par = {
        code: this.code,
        email: this.email.trim(),
        passWord: md5(this.passWord),
      };
      this.http
        .APIASK(this.ports.bindEmail, 'post', par)
        .then((res) => {
          this.loading = false;
          Toast.succeed('绑定成功');
          this.showemail = false;
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    getDeclareHistoryList() {
      this.http
        .APIASK(this.ports.declareHistoryList, 'post', {})
        .then((res) => {
          // this.declarantList = res;
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    getcoupindex(index) {
      if (this.allcoupons[index].thresholdPrice <= this.grancount) {
        this.coupcde = index;
      }
    },
    getalladdres() {
      var par = this.par;
      if (!par.address.id) {
        Toast.hide();
        return;
      }
      this.alladdres = par.address.concatAddress;
    },
    getshopid() {
      const par = {
        id: this.shopid,
      };
      this.http
        .APIASK(this.ports.addressthe, 'get', par)
        .then((res) => {
          this.par.address = res;
          this.type = this.pickerDatatype[1];
          this.getalladdres();
          this.getServe(this.par.address.countryId);
          this.servicePricelist(this.par.address.countryId);
          Toast.hide();
        })
        .catch((err) => {
          this.loading = false;
          Toast.hide();
        });
    },
    csancelcoup() {
      this.isSelectorShow = false;
      this.loading = false;
      this.coupid = '';
      this.coupcde = null;
      var price = 0;
      this.counp = '有優惠券可使用';
      this.coupprice = price;
      console.log('this.coupprice', this.coupprice)
    },
    hasMallInfo() {
      const par = {
        countryId: JSON.parse(localStorage.getItem('userinfoMobie')).disVo.id,
      };
      this.http
        .APIASK(this.ports.hasMallInfo, 'post', par)
        .then((res) => {
          this.ispae = res;
          if (!this.ispae) {
            this.type = this.pickerDatatype[0];
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    summit() {
      if (this.type.value == '1' && this.par.address.isSuperMall != 0) {
        Toast.failed('配送類型與收件人地址不一致');
        return;
      }
      if (this.type.value == '2' && this.par.address.isSuperMall == 0) {
        Toast.failed('配送類型與收件人地址不一致');
        return;
      }
      const pars = {
        serviceId: this.countryid,
        price: this.yunprice,
      };
      this.http
        .APIASK(this.ports.checkSubmit, 'post', pars)
        .then((res) => {
          if (res.status) {
            this.loading = true;
            this.submatall();
          } else {
            if (res.code === '1002') {
              Dialog.confirm({
                content: res.text,
                confirmText: '確定',
                onConfirm: () => {
                  this.submatall();
                },
              });
            } else {
              Dialog.failed({
                title: '提交失敗',
                content: res.text,
                confirmText: '確定',
              });
              this.loading = false;
            }
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    submatall() {
      const par = {
        countryId: this.par.address.countryId,
      };
      this.http.APIASK(this.ports.orderMergeNotice, 'get', par).then((res) => {
        if (res) {
          Dialog.confirm({
            content: res,
            confirmText: '確定',
            onConfirm: () => {
              this.orderMergeNotice();
            },
            onCancel: () => {
              this.loading = false;
            },
          });
        } else {
          this.orderMergeNotice();
        }
      });
    },
    jiesilie(arr) {
      let obj = {
        addedServiceId: arr.id,
        ids: [],
      };
      arr.parcelList.map((val) => {
        if (val.check) {
          obj.ids.push(val.id);
        }
      });
      return obj;
    },
    orderMergeNotice() {
      // 遍历申报人列表
      let declarantList = [];
      this.declarantList.forEach((item, index) => {
        declarantList.push(item.id);
      });
      var addedid = [];
      var addedlist = JSON.parse(JSON.stringify(this.addedlist));
      if (addedlist.length > 0) {
        for (var i = 0; i < addedlist.length; i++) {
          if (addedlist[i].status) {
            addedid.push(addedlist[i].id);
          }
        }
      }
      let lisparc = JSON.parse(JSON.stringify(this.addedlist)).filter((val) => {
        return val.addprc > 0;
      });
      let adrlist = [];
      lisparc.map((val) => {
        adrlist.push(this.jiesilie(val));
      });

      const par = {
        addedSplitChargeTypeParam: adrlist,
        addeds: addedid,
        address: this.par.address.id,
        couponsId: this.coupid,
        ids: JSON.parse(this.$route.query.ids),
        isProtection: this.isRein.isProtection ? this.isProtection : 0,
        isReinforce: this.isRein.isReinforce ? this.isReinforce : 0,
        serviceId: this.countryid,
        isReplace: this.replace,
        remark: this.remark,
        replacePrice: this.replace ? parseFloat(this.replacePrice) : null,
        declaredIds: declarantList,
        creditStatus: this.creditStatus,
        customsDeclarationDemand: this.customsDeclarationDemand,
      };
      this.http
        .APIASK(this.ports.ordersubmit, 'post', par)
        .then((res) => {
          localStorage.setItem('fleshpack', 1);
          localStorage.setItem('fleshorder', 1);
          if (this.chargeMode === 2) {
            Dialog.alert({
              title: '订单提交',
              content: '订单已提交，该订单需在仓库打包并制单完成后付款，请耐心等待，谢谢！',
              cancelText: '取消',
              confirmText: '确定',
              onConfirm: () => this.$router.push({
                name: 'Order',
              }),
            })

          } else {
            this.$router.replace({
              name: 'Pay',
              query: {
                id: res.id,
                price: this.allprice,
              },
            });
          }

        })
        .catch((err) => {
          this.loading = false;
          setTimeout(() => {
            // this.showemail = true;
          }, 500);
        });
    },
    toaddresh() {
      localStorage.setItem('fleshpei', '11');
      if (this.type.value == '1') {
        this.$router.push({
          name: 'AddressUser',
          query: {
            addresid: this.par.address.id ? this.par.address.id : '',
            index: 1,
          },
        });
      } else {
        this.$router.push({
          name: 'Checkadres',
          query: {
            ids: this.$route.query.ids,
          },
        });
      }
    },
    hanchangetwo() {
      this.checkedone ? (this.isProtection = 1) : (this.isProtection = 0);
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );
    },
    hanchangeone(id, type, name, index) {
      if (type === 1) {
        console.log(this.addedlist);
        console.log(id);
        this.getallprice(
          this.checkedtwo ? this.par.reinforcePrice : 0,
          this.checkedone ? this.par.protectionPrice : 0,
          this.coupprice
        );
      } else {
        this.checkindex = index;
        this.checlist = JSON.parse(JSON.stringify(this.addedlist[index]));
        this.shotable = true;
        this.title = '请选择需要' + name + '包裹';
        console.log(this.addedlist[index]);
        this.addedlist[index].status = false;
      }
    },
    cheall() {
      this.checlist.check = !this.checlist.check;
      if (this.checlist.check) {
        this.checlist.parcelList.map((val) => {
          val.check = true;
        });
      } else {
        this.checlist.parcelList.map((val) => {
          val.check = false;
        });
      }
      this.geunurusn();
    },
    shurepae() {
      this.addedlist[this.checkindex] = this.checlist;
      if (this.addedlist[this.checkindex].addprc > 0) {
        this.addedlist[this.checkindex].status = true;
      } else {
        this.addedlist[this.checkindex].status = false;
      }

      this.shotable = false;
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );
      console.log(this.addedlist);
    },
    cheindex(indexc) {
      this.checlist.parcelList[indexc].check =
        !this.checlist.parcelList[indexc].check;
      this.geunurusn();
    },
    geunurusn() {
      let psubeu = [];
      this.checlist.parcelList.filter((val) => {
        if (val.check) {
          psubeu.push(val.id);
        }
      });
      console.log('psubeu', psubeu.length);
      console.log('checlist', this.checlist);

      if (psubeu.length > 0) {
        if (psubeu.length === this.checlist.parcelList.length) {
          this.checlist.check = true;
        } else {
          this.checlist.check = false;
        }
        const par = {
          addedServiceId: this.checlist.id,
          ids: psubeu,
        };

        this.http
          .APIASK(this.ports.getAddedCharge, 'post', par)
          .then((res) => {
            this.checlist.addprc = res.addedPrice;
            console.log('res', res);
          })
          .catch((err) => {
            this.loading = false;
            Toast.hide();
          });
      } else {
        this.checlist.addprc = 0;
        this.checlist.check = false;
      }
    },
    $_selected(item) {
      this.type = item;
      if (this.type.value == '2') {
        this.$router.push({
          name: 'Checkadres',
          query: {
            ids: this.$route.query.ids,
          },
        });
      } else {
        if (this.shopid) {
          this.shopid = null;
          this.toaddresh();
        }
      }
    },
    onPickerConfirm(index) {
      if (this.$refs.picker1.getColumnValue().value != this.countryid) {
        this.csancelcoup();
        this.countryid = this.$refs.picker1.getColumnValue().value;
        this.cheur();
        this.country = this.$refs.picker1.getColumnValue().text;
        this.elapsedTime =
          this.country[this.$refs.picker1.getColumnIndex()].elapsedTime;
      }
      this.ischargeMode()
    },
    ischargeMode() {
      if (this.countryList.length > 0) {
        let chenmosme = this.countryList.find(val => {
          return val.id === this.countryid
        })
        this.chargeMode = chenmosme.chargeMode
      }

      console.log('chenmosme', this.chargeMode)
    },
    cheurusner() {
      if (this.replacePrice) {
        this.cheur()
      }

    },
    cheur() {
      Toast.loading('加载中...');
      console.log('par', this.par)
      const par = {
        serviceId: this.countryid,
        countryId: this.par.address.countryId,
        ids: JSON.parse(this.$route.query.ids),
        addressId: this.par.address.id,
        isReplace: this.replace,
        replacePrice: this.replacePrice ? this.replacePrice : 0
      }
      this.http.APIASK(this.ports.getTriggerParcelTotalSurchargesMoney, 'post', par).then(res => {
        console.log('res', res)
        console.log('this.par', this.par)
        this.$set(this.par, 'triggerParcelTotalSurchargesMoney', res)
        this.par.triggerParcelTotalSurchargesMoney.list = res.list
        this.getprice(this.countryid);

      }).catch(err => {
        if (err.code === 'EE01') {
          Toast.hide()
          this.replacePrice = ''
          Toast.failed(err.message);
          setTimeout(() => {
            this.cheur()
          }, 500);

        }

      })
    },

    onPickercust() {
      this.customsDeclarationDemand = this.$refs.picker4.getColumnValue().value;
      this.customsDeclara = this.$refs.picker4.getColumnValue().text;
    },
    changeAllPrice(e) {
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );
      // if(this.creditStatus) {
      //   let parce=this.allprice - this.creditPrice;
      //   this.allprice = parseFloat(parce) .toFixed(2)
      // }else {
      //   let parce=parseFloat(this.allprice)  + this.creditPrice;
      //   this.allprice = parseFloat(parce).toFixed(2)
      // }
    },
    // 统计合计总价
    getallprice(reinforcePrice, protectionPrice, coupprice) {
      var money =
        (parseFloat(this.par.billing.rat) != NaN
          ? parseFloat(this.par.billing.rat)
          : 0) +
        (parseFloat(this.grancount) != NaN
          ? parseFloat(this.grancount)
          : 0) +
        (parseFloat(this.par.timeOutPrice) != NaN
          ? parseFloat(this.par.timeOutPrice)
          : 0) +
        (parseFloat(reinforcePrice) != NaN ? parseFloat(reinforcePrice) : 0) +
        (parseFloat(protectionPrice) != NaN ? parseFloat(protectionPrice) : 0) -
        (parseFloat(coupprice) != NaN ? parseFloat(coupprice) : 0);
      var addedprice = 0;
      var sunjne = JSON.parse(
        JSON.stringify(this.par.triggerParcelTotalSurchargesMoney.list)
      );
      var ajenr = 0;
      var parcelTotalSurchargesMoney = 0;
      if (this.chargeMode === 1) {
        parcelTotalSurchargesMoney = this.par.parcelTotalSurchargesMoney
        if (sunjne.length > 0) {
          for (let i = 0; i < sunjne.length; i++) {
            ajenr = ajenr + sunjne[i].totalPrice;
          }
        }
      }
      console.log('sunjne', sunjne);
      for (let i = 0; i < this.addedlist.length; i++) {
        if (
          this.addedlist[i].status &&
          this.addedlist[i].splitChargeType === 1
        ) {
          addedprice = addedprice + this.addedlist[i].addedPrice;
        } else if (
          this.addedlist[i].status &&
          this.addedlist[i].splitChargeType === 2
        ) {
          addedprice = addedprice + this.addedlist[i].addprc;
        }
      }
      if (this.chargeMode === 2) {
        this.creditPrice = false
      }
      if (this.creditStatus) {
        let parce = money - this.creditPrice;
        this.allprice = (
          parseFloat(parce) +
          parseFloat(ajenr) +
          parseFloat(parcelTotalSurchargesMoney) +
          addedprice
        ).toFixed(2);
      } else {
        let parce = money;
        this.allprice = (
          parseFloat(parce) +
          parseFloat(ajenr) +
          parseFloat(parcelTotalSurchargesMoney) +
          addedprice
        ).toFixed(2);
      }

      this.isSelectorShow = false;
    },
    getdetaile() {
      var ar = '?ids=' + JSON.parse(this.$route.query.ids).join('&ids=');
      this.http
        .APIASK(this.ports.orderready + ar, 'get')
        .then((res) => {
          this.parcelList = res.parcelList;
          let custList = JSON.parse(
            JSON.stringify(res.customsDeclarationDemand)
          );
          this.par = res;
          const coustkerData = custList.map(function (item, index) {
            // tslint:disable-next-line:radix
            return {text: item.message, value: item.code};
          });
          var par = this.par;
          if (par.address.id) {
            if(!this.isshowModal){
              this.checkEntrust()
            }
          }

          this.coustkerData.push(coustkerData);
          console.log(this.coustkerData);
          this.customsDeclara = this.coustkerData[0][0].text;
          this.customsDeclarationDemand = this.coustkerData[0][0].value;
          this.par.servicePriceList.length > 0
            ? this.getlist(JSON.stringify(this.par.servicePriceList[0].list))
            : null;
          if (this.$route.query.shopid) {
            this.getshopid();
          } else {
            this.getalladdres();
            if (this.par.address.id) {
              this.getServe(this.par.address.countryId);
              setTimeout(function () {
                Toast.hide();
              }, 100);
            }
          }
        })
        .catch((err) => {
          Toast.hide();
        });
    },
    servicePricelist(id) {
      const ids = JSON.parse(this.$route.query.ids);
      const par = {
        fromCountry: '',
        id: '',
        toCountry: id,
      };
      this.http
        .APIASK(this.ports.servicePricelist + '?parcelIds=' + ids, 'get', par)
        .then((res) => {
          this.par.servicePriceList = res;
          this.par.servicePriceList.length > 0
            ? this.getlist(JSON.stringify(this.par.servicePriceList[0].list))
            : null;
        });
    },
    getcouefrt() {
      if (this.allcoupons.length > 0) {
        this.isSelectorShow = true;
      } else {
        Toast.failed('暫無可使用的優惠券');
      }
    },
    // 获取优惠券绑定国家列表
    getcoupCountry() {
      var resutl = this.par.coupons.filter(
        (item) =>
          item.countryId == this.par.address.countryId || !item.countryId
      );
      Toast.hide();
      this.allcoupons = resutl;
      this.choione(resutl);
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );
      // if (this.allcoupons.length > 0) {
      //   this.choione(resutl)
      //   this.isSelectorShow = true
      // } else {
      //   Toast.failed('暫無可使用的優惠券')
      // }
    },
    choione(resutl) {
      if (resutl.length > 0) {
        const findvake = resutl.filter((val) => {
          return val.thresholdPrice <= this.grancount;
        });
        if (findvake.length > 0) {
          this.coupcde = 0;
          console.log('有可使用的券');
          this.onSelectorChoose();
        } else {
          this.coupcde = null;
          this.counp = '暫無優惠券可使用';
          this.onSelectorChoose();
        }
      } else {
        this.coupcde = null;
        this.counp = '暫無優惠券可使用';
        this.onSelectorChoose();
      }
    },
    hidePopUp() {
      this.coupid = '';
      this.coupcde = null;
      var price = 0;
      this.counp = '有優惠券可使用';
      this.coupprice = price;
      this.getCreditPrice();
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );
    },
    onSelectorChoose() {
      if (this.coupcde == null) {
        this.isSelectorShow = false;
        this.getCreditPrice();
        return;
      }
      var finitem = this.allcoupons[this.coupcde];
      if (finitem.thresholdPrice > this.grancount) {
        return;
      }
      console.log('this.grancount', this.grancount)
      this.coupid = finitem.id;
      var price = 0;
      if (finitem.type == 2) {
        price =
          this.grancount -
          (this.grancount * finitem.price) / 10;
      } else {
        if (parseFloat(this.grancount) >= parseFloat(finitem.price)) {
          console.log('234w')
          price = finitem.price;
        } else {
          price = this.grancount
        }
      }
      this.counp =
        this.allcoupons[this.coupcde].name +
        '(' +
        parseFloat(price).toFixed(2) +
        'CNY' +
        ')';
      if (this.chargeMode === 2) {
        this.coupprice = 0;
        this.coupid = null;
      } else {
        this.coupprice = price;
      }
      console.log('this.coupprice', this.coupprice)
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );

      // 选择优惠券后获取积分抵扣
      this.getCreditPrice();
    },
    cancelChoose() {
      this.csancelcoup();
      this.getallprice(
        this.checkedtwo ? this.par.reinforcePrice : 0,
        this.checkedone ? this.par.protectionPrice : 0,
        this.coupprice
      );
    },
    getlist(re) {
      //
      this.pickerData = [];
      var res = JSON.parse(re);
      //console.log(res);
      var finbval = [];
      finbval = this.par.parcelList.filter((item) => item.type === 1);
      var goovalue = res.filter((item) => item.type === 1);
      //console.log(goovalue);
      //console.log(finbval);
      var listValue = [];
      finbval.length > 0 ? (listValue = goovalue) : (listValue = res);
      console.log('listValue', listValue)
      listValue.length > 0
        ? this.getprice(listValue[0].id)
        : Toast.info('你選擇的地址沒有特貨線路，請重新選擇');
      listValue.length > 0
        ? (this.elapsedTime = listValue[0].elapsedTime)
        : null;
      listValue.length > 0
        ? (this.countryList = listValue)
        : (this.countryList = []);
      listValue.length > 0 ? (this.country = listValue[0].transCode) : null;
      listValue.length > 0 ? (this.countryid = listValue[0].id) : null;
      //console.log(this.countryid);
      const result = this.countryList.map(function (item, index) {
        // tslint:disable-next-line:radix
        return {text: item.transCode, value: item.id};
      });
      console.log('result123', result)
      this.pickerData.push(result);
      this.cheur()
      // this.getprice(this.countryid)
    },
    getprice(id) {
      const par = {
        id: id,
        weight: this.par.bulk,
        warehouse: this.par.warehouse,
        realWeight: this.par.realWeight,
      };
      this.http.APIASK(this.ports.realPrice, 'get', par).then((res) => {
        res.isGoodsTax == 1
          ? (res.rat = ((res.taxRate / 100) * pars.totalPrice).toFixed(2))
          : (res.rat = 0);
        this.par.billing = res;
        this.yunprice = this.par.billing.price.toFixed(2);
        this.timeOutPrice = this.par.timeOutPrice.toFixed(2);
        console.log('this.grancount', this.grancount)
        this.ischargeMode();
        this.getzheou();

      }).catch(err => {
        Toast.hide();
      })
    },
    getzheou() {

      if (this.chargeMode === 1) {
        const par = {
          countryId: this.par.address.countryId,
        };
        this.http.APIASK(this.ports.getUserGradeDiscount, 'get', par).then((res) => {
          this.gradecomt = res
          if (res) {
            this.grancount = (this.par.billing.price * res.discount / 10).toFixed(2)
            console.log('this.grancount', this.grancount)
          } else {
            this.grancount = this.par.billing.price.toFixed(2);
          }

          this.getcoupCountry();
        });
      } else {
        this.grancount = this.par.billing.price.toFixed(2);
        this.gradecomt = null
        this.getcoupCountry();
      }

    },
    checkEntrust() {
      if(this.par.address.countryCode==='TW'){
        this.isshowModal=true
        this.http.APIASK(this.ports.checkEntrust, 'post', {
          type: 1,
          id: this.par.address.id
        }).then((res) => {
          this.isshowModal=false
          console.log('qqewres', res)
        }).catch(err=>{
          Dialog.alert({
            title: '提示',
            content: err.message,
            confirmText: '确定',
            onConfirm: () =>{
              this.isshowModal=false
            },
          })
        });
      }

    },
    getServe(id) {
      const par = {
        countryId: id,
        ids: JSON.parse(this.$route.query.ids),
      };
      let parcelList = JSON.parse(JSON.stringify(this.par.parcelList));
      parcelList.map((val) => {
        val.check = false;
      });

      this.http.APIASK(this.ports.getAdded, 'post', par).then((res) => {
        res.map((val) => {
          val.status = false;
          val.addprc = 0;
          val.check = false;
          val.parcelList = parcelList;
        });
        this.addedlist = res;
      });
      this.http.APIASK(this.ports.isRemark, 'get', {countryId: id}).then(res => {
        this.shoremark = res
        console.log('res,', res)
      })

    },
    // 申报人配置
    toDeclarantList() {
      if (this.par.address.countryId === null) {
        Toast.failed('请先配置收货地址');
        return;
      }
      this.$router.push({
        name: 'Declarant',
        query: {
          countryId: this.par.address.countryId, // 配送地址的国家ID
        },
      });
    },
    deleteDeclarant(record, index) {
      Dialog.confirm({
        content: '请确认是否删除该申报人',
        confirmText: '确定',
        onConfirm: () => {
          this.declarantList.splice(index, 1);
          // this.http
          //   .APIASK(this.ports.deleteDeclare, "post", { id: record.id })
          //   .then(res => {
          //     this.declarantList.splice(index, 1);
          //   });
        },
      });
    },
  },
};
</script>

<style lang="less">
.orderpackcaontein {
  fieldset {
    padding-top: 0;
    padding-bottom: 0;
  }

  .md-field {
    padding: 0.2rem;
  }

  .md-cell-item-body {
    padding: 0.2rem 0;
  }

  .md-cell-item-left {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .md-cell-item-brief {
    text-align: left;
    font-size: 0.26rem;
  }

  .md-cell-item-title {
    font-size: 0.26rem;
  }

  .noright {
    .md-cell-item-content {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .md-cell-item-brief {
        width: 70%;
        margin-top: 0;
        font-size: 0.26rem;
      }
    }
  }

  .md-cell-item-children {
    padding: 0.2rem 0;
  }

  .cheildercomt {
    font-size: 0.28rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    p {
      width: 74%;
      text-align: left;
    }
  }

  .cheildercomt:before {
    content: '';
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }

  .cheildercomtonier {
    font-size: 0.26rem;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: -1rem;

    p {
      width: 74%;
      padding-bottom: 0.2rem;
      display: flex;
      align-items: center;
    }
  }

  .cheildercomtonier:before {
    content: '';
    position: absolute;
    z-index: 2;
    -webkit-transform: scaleY(0.5) translateY(100%);
    transform: scaleY(0.5) translateY(100%);
    bottom: 0;
    left: 0;
    right: auto;
    top: auto;
    width: 100%;
    border-bottom: 0.02rem solid #e2e4ea;
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
  }

  .md-cell-item-title {
    text-align: left;
  }

  .allshow {
    width: 100%;
    background-color: white;
    font-size: 0.26rem;

    p {
      padding-left: 5%;
      text-align: left;
    }
  }

  .selector-item-body {
    display: flex;
    align-items: center;
  }

  .bootomsubmit {
    width: 100%;
    height: 1rem;
    position: fixed;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
    z-index: 999;

    p {
      font-size: 0.38rem;
      color: #e51c23;
      padding-left: 0.26rem;

      span {
        font-size: 0.3rem;
      }
    }
  }

  .coupcontainer {
    width: 100%;
    max-height: 7rem;
    overflow-y: scroll;
    background-color: white;
    padding: 0.2rem 0;

    .coupitem {
      width: 94%;
      height: 1.5rem;
      margin-left: 3%;
      border: 1px solid #f0f0f2;
      box-shadow: 2px 2px 7px 2px rgba(207, 207, 207, 0.5);
      margin-top: 0.1rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: relative;

      .coupitemleft {
        width: 40%;
        display: flex;
        height: 55%;
        flex-direction: column;
        justify-content: space-around;
        padding-right: 0.2rem;
      }

      .coupitemright {
        width: 60%;
        display: flex;
        height: 55%;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-around;
      }

      .messageimg {
        position: absolute;
        right: 0;
        top: 0;
      }
    }

    .nocolor {
      background-color: #f0f0f2;
    }
  }

  .md-tag .shape-fillet {
    padding: 0.12rem 0.2rem !important;
  }

  .packtitle {
    width: 90%;
    margin-left: 5%;
    height: 0.6rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.3rem;
  }

  .packcontilist {
    width: 100%;
    background-color: white;
    padding-top: 0.2rem;
  }

  .listmkck {
    width: 100%;
  }

  .listpack {
    width: 100%;
    display: flex;
    font-size: 0.26rem;
    padding: 0.1rem 0;

    .packindex {
      width: 10%;
      text-align: center;
    }

    .packnumber {
      width: 35%;
      text-align: left;
    }

    .packtype {
      width: 10%;
      text-align: left;
    }

    .packweight {
      width: 20%;
      text-align: left;
    }

    .packvalue {
      width: 18%;
      text-align: left;
      display: flex;
    }


  }

  .title {
    font-size: 0.26rem !important;
    text-align: left;
    padding-left: 1%;
    line-height: 0.8rem;
    font-weight: bolder;
  }

  .declared_container {
    background: white;
    padding: 0.2rem;
    flex-direction: column;
    display: flex;
    align-items: center;
    font-size: 0.26rem;
    margin-top: 0.5rem;

    table {
      width: 100%;

      .header {
        color: #888888;
        line-height: 0.26rem;

        th:first-child {
          width: 15%;
        }

        th:last-child {
          width: 10%;
        }
      }

      .content {
        line-height: 0.6rem;
      }
    }

    .title {
      font-size: 0.26rem;
      text-align: left;
      font-weight: bold;
      margin: 0.2em 0 0.5em 0;
    }
  }
}

.content {
  margin-top: -0.5rem;
}

.bordernone {
  border-bottom: 1px solid #f2f2f2;
  padding: 0.2rem 0;
}

.uwne {
  width: 90%;
}

.emadilcontainer {
  width: 100%;
  padding: 0.5rem 0;
  background-color: white;
}

.logo {
  width: 0.6rem;
}

.inner-popup {
  width: 100%;
}

.md-example-popup-align {
  width: 7rem;
  height: 7.2rem;
  background-color: white;
  overflow-y: scroll;
}

.headeritem {
  display: flex;
  width: 96%;
  margin-left: 2%;
  display: flex;
  align-items: center;
  font-size: 0.24rem;
  margin-bottom: 0.1rem;
}

.headerchek {
  width: 96%;
  margin-left: 2%;
  display: flex;
  align-items: center;
  height: 1rem;
  font-size: 0.28rem;
}

.cheicon {
  width: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chetyle {
  width: 40%;
  display: flex;
  align-items: center;
}

.weigconten {
  width: 20%;
  display: flex;
  align-items: center;
}

.volumche {
  width: 30%;
  display: flex;
  align-items: center;
}

.unskr {
  height: 5rem;
  overflow-y: scroll;
}

.bottomview {
  height: 1.3rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  span {
    font-size: 0.3rem;
    text-align: left;
    padding-left: 0.26rem;
    color: orangered;
  }

  .unsuner {
    width: 95%;
    display: flex;
    justify-content: flex-end;
  }
}

.md-input-item-fake,
.md-input-item-input {
  font-size: 0.26rem;
  height: 0.6rem;
}
</style>
